import apiClient, { apiFormClient } from "../utils/apiClient";

// Upload 1 chunk video (multipart). Hợp đồng BE: POST /api/video/upload
// fields: file (blob chunk), idVideo, currentIndex, totalChunks.
const uploadChunk = async (idVideo, blob, currentIndex, totalChunks) => {
    const formData = new FormData();
    formData.append("file", blob, `${idVideo}.part${currentIndex}`);
    formData.append("idVideo", idVideo);
    formData.append("currentIndex", String(currentIndex));
    formData.append("totalChunks", String(totalChunks));

    const response = await apiFormClient.post("/api/video/upload", formData);
    return response.data;
};

// Lấy trạng thái xử lý video (UPLOADING/READY/MERGING/DONE/FAILED/...) + final_hls_url.
const getVideoStatus = async (idVideo) => {
    const response = await apiClient.get(`/api/video/${idVideo}`);
    return response.data?.data;
};

export const VIDEO_API = {
    uploadChunk,
    getVideoStatus,
};
